var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 15.8332C3.8335 16.2752 4.00909 16.6991 4.32165 17.0117C4.63421 17.3242 5.05814 17.4998 5.50016 17.4998C5.94219 17.4998 6.36611 17.3242 6.67867 17.0117C6.99123 16.6991 7.16683 16.2752 7.16683 15.8332C7.16683 15.3911 6.99123 14.9672 6.67867 14.6547C6.36611 14.3421 5.94219 14.1665 5.50016 14.1665C5.05814 14.1665 4.63421 14.3421 4.32165 14.6547C4.00909 14.9672 3.8335 15.3911 3.8335 15.8332Z",
    stroke: "#707070",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9168 14.1667H5.50016V2.5H3.8335",
    stroke: "#707070",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 4.1665L17.1667 4.99984L16.4508 10.009M14.25 10.8332H5.5M16.3333 13.3332V18.3332M16.3333 18.3332L18.8333 15.8332M16.3333 18.3332L13.8333 15.8332",
    stroke: "#707070",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.31e27e1a17b555012ea8cc883f4f562d.svg";
export { ForwardRef as ReactComponent };